import { FunctionComponent as F, useEffect, useState } from "react";
import MedicationLiquidIcon from '@mui/icons-material/MedicationLiquid';
import MedicationIcon from '@mui/icons-material/Medication';
import ColorizeIcon from '@mui/icons-material/Colorize';
import LiquorIcon from '@mui/icons-material/Liquor';
import units from "../../../core/units";


export interface FormIconDosing
{
  productId: number,
  formId: number,
  amount?: number,
  amountUnitId?: number,
  dose?: number,
  doseUnitId?: number
}

interface IProps
{
  dosing: FormIconDosing
}

const FormIcon: F<IProps> = (props: IProps) =>
{
  const formId = props.dosing.formId;

  const [productAmountMl, setProductAmountMl] = useState<number | undefined>(undefined);
  const [doseAmountMl, setDoseAmountMl] = useState<number | undefined>(undefined);

  useEffect(() =>
  {
    if(props.dosing.amountUnitId && props.dosing.amount)
    {
      units.getFactor(props.dosing.amountUnitId, 2, [props.dosing.productId])
        .then(f => setProductAmountMl((Number(props.dosing.amount) * (f || 0)) || undefined));
    }

    if(props.dosing.doseUnitId && props.dosing.dose)
    {
      units.getFactor(props.dosing.doseUnitId, 2, [props.dosing.productId])
        .then(f => setDoseAmountMl(f ? Number(props.dosing.dose) * f : undefined));
    }
  }, []);

  if(formId === 1)        // Capsule
  {
    return <MedicationIcon style={{ fontSize: 20, cursor: 'pointer', color: 'gray'}}/>;
  }
  else if(formId === 2 && doseAmountMl !== undefined)   // Liquid
  {
    if(productAmountMl && productAmountMl > 200 || doseAmountMl > 10)
      return <LiquorIcon style={{ fontSize: 20, cursor: 'pointer', color: 'gray'}}/>;

    return <ColorizeIcon style={{ fontSize: 20, cursor: 'pointer', color: 'gray'}}/>;
  }
  else if(formId === 3)   // Solid
  {
    return <MedicationLiquidIcon style={{ fontSize: 20, cursor: 'pointer', color: 'gray'}}/>;
  }
  else
  {
    return <MedicationIcon style={{ fontSize: 20, cursor: 'pointer', color: 'gray'}}/>;
  }
}

export default FormIcon;